export function addProtocolIfMissing(url: string) {
  var protocolPattern = /^(https?):\/\//;

  if (!protocolPattern.test(url)) {
    return 'https://' + url;
  }

  return url;
}